import { Popover, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import React from "react";
import classes from "./UserScopesPopover.module.css";
import { getIconByScope, getSiteByScopeId, getSortedUserScopes } from "../../../../utils/UsersUtils";

const UserScopesPopover = (props) => {
  const sites = useSelector((state) => state.user.sites);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const userScopes = getSortedUserScopes(sites, props?.userScopes);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <div>
        <Typography
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          <span>
            {userScopes?.map((us) => {
              return (
                <span key={us.id}>
                  {getIconByScope(sites, us.scope, classes.icons)}
                </span>
              )
            })}
          </span>
        </Typography>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        
      >
        <div sx={{ p: 1 }}>
          {userScopes?.map((us) => {
            const site = getSiteByScopeId(sites, us.scopeId);
            return (
              <div key={us.id} className={classes.site}>
                {getIconByScope(sites, us.scope)}
                <span className={classes.displayName}>{site ? site?.displayName : us.scope?.name}</span>
                <span className={classes.userType}> , {us.role?.name}</span>
              </div>
            );
          })}
        </div>
      </Popover>
    </div>
  );
};

export default UserScopesPopover;